module.exports = __webpack_public_path__ + "media/Face_Restoration.51392c07.webm";